module.exports = __webpack_public_path__ + "img/img (61).376499ea.jpg";